<template>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel  profile-panel profile-bio">
                <empty-state
                        :title="$t('wi.profile')"
                        :description="$t('wi.tell_your_story_in_your_own_words')"
                        :button="{caption: $t('wi.add_profile_information')}"
                        v-if="!hasBiography"
                        modalTarget='editBio'
                />
                <template v-else>
                    <edit-button modal-target="editBio"/>
                    <h3 v-text="$t('wi.profile')" class="tw-mb-10 text-center"></h3>
                    <p v-for="bio in biography.split('\n')" v-html="bio" class="tw-mb-3"></p>
                </template>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
  import {mapGetters} from 'vuex';
  import EmptyState from './EmptyState';
  import EditButton from './VisualElements/EditButton';
  import {trim} from 'lodash';

  export default {
    name: 'Biography',
    components: {
      EditButton,
      EmptyState
    },
    computed: {
      ...mapGetters({
        bioData: 'player-profile/bio'
      }),
      biography() {
        return !!this.hasBiography ? trim(this.bioData.metas[0].value.content) : null;
      },
      hasBiography() {
        return this.bioData !== null && !! trim(this.bioData.metas[0].value.content);
      }
    }
  };
</script>
